import PubSub from 'pubsub-js'

export const fireEvent = (topic, event) => PubSub.publish(topic, event)
export const fireEventSync = (topic, event) => PubSub.publishSync(topic, event)

export const eventSubscribe = (topic, subscriber) =>
  PubSub.subscribe(topic, subscriber)

export const eventUnSubscribe = subscription => PubSub.unsubscribe(subscription)
